module.exports = __webpack_public_path__ + "static/media/notifications.a00fe84d.png";